import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE1_3 = () => (
  <Section gapBefore>

    <UL>
      <LI>
        <P>
          Lassen Sie in Partnerarbeit eine <b>Mind-Map</b> mit dem Begriff Kleidung im Zentrum erstellen (für fortgeschrittenere SuS). Anschließend (oder um die Aufgabe zu vereinfachen) wird eine gemeinsame Mind-Map im Klassenverband zusammengetragen.
        </P>
        <P>
          Vermerken Sie hierauf auch, wie häufig bestimmte Begriffe jeweils in Partnerarbeit gefunden wurden, z. B. Mode/Style/bestimmte Marken etc. Erörtern Sie die Begriffe im Klassenverband. Lassen Sie die Mind-Map sichtbar stehen und erweitern Sie diese im Laufe der folgenden Lerneinheiten.
        </P>
      </LI>
      <LI gapBefore>
        Hausaufgabe und Übergang zum Thema Fast Fashion:
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE1_3.js